<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 18:53:40
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-31 11:14:21
 * @name: 权限管理模块路由
 * @Description: 权限管理模块路由
 * @FilePath: \preSaleNafterSaleBackstage\src\views\jurisdiction\jurisdictionRouter.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <keep-alive :include="cashRouters">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: 'roleRouter',
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
}
</script>